<template lang="pug">
div
    // RESUMO DOS CÁLCULO TOTAIS CERTIDAO
    .px-30(v-if="formaPagamento === 'A_VISTA' && (tipoProcesso === 'CERTIDAO_TITULO' || (!excedente && (!dadosVtn.respeitaLegislacaoAmbiental && !dadosVtn.temDireitoRegularizacao)))")
      el-table.mt-3(
        v-if="dadosVtn.calculosVtn.resumoVtn"
        :data="dadosVtn.calculosVtn.resumoVtn"
      )
        el-table-column(label="Resumo", prop="descricao")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtn.length - 1 }") {{ scope.row.descricao }} &nbsp
            el-tooltip(v-if="scope.row.descricao === 'Custas agrárias'", effect='dark', :content='msgAgrarias', placement="right")
              i.fa.fa-question-circle
        el-table-column(label="Valor (R$)", prop="valor")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtn.length - 1 }") {{ scope.row.valor | formatDouble }}
        el-table-column(label="Quantidade em UPFPA", prop="quantidadeUPFPA")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtn.length - 1 }") {{ scope.row.quantidadeUPFPA | formatDouble }}

    // RESUMO DOS CÁLCULOS TOTAIS COM DESCONTOS
    .px-30(v-if="(formaPagamento === 'A_VISTA' || formaPagamento === 'PARCELADO') && (dadosVtn.respeitaLegislacaoAmbiental || dadosVtn.temDireitoRegularizacao) && !excedente")
      el-table.mt-3(
        v-if="dadosVtn.calculosVtn.resumoVtnComDesconto"
        :data="dadosVtn.calculosVtn.resumoVtnComDesconto"
      )
        el-table-column(label="Resumo com desconto", prop="descricao")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtnComDesconto.length - 1 }") {{ scope.row.descricao }} &nbsp
            el-tooltip(v-if="scope.row.descricao === 'Custas agrárias'", effect='dark', :content='msgAgrarias', placement="right")
              i.fa.fa-question-circle

          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtnComDesconto.length - 1 }") {{ scope.row.descricao }} &nbsp
            el-tooltip(
              v-if="scope.row.tipoDesconto === 'RESPEITA_LEGISLACAO_AMBIENTAL' || scope.row.tipoDesconto === 'TEM_DIREITO_REGULARIZACAO'",
              effect='dark',
              :content="getMensagem(scope.row.tipoDesconto)",
              placement="top"
            )
              font-awesome-icon.icon(icon="info-circle" size="1x")
        el-table-column(label="Valor (R$)", prop="valor")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtnComDesconto.length - 1 }") {{ scope.row.valor | formatDouble }}
        el-table-column(label="Quantidade em UPFPA", prop="quantidadeUPFPA")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtnComDesconto.length - 1 }") {{ scope.row.quantidadeUPFPA | formatDouble }}

    // RESUMO DOS CÁLCULOS TOTAIS
    .px-30(v-if="formaPagamento === 'PARCELADO' && !(dadosVtn.respeitaLegislacaoAmbiental || dadosVtn.temDireitoRegularizacao) && !excedente")
      el-table.mt-3(
        :data="getResumoVtn"
      )
        el-table-column(label="Resumo", prop="descricao")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtn.length - 1}") {{ scope.row.descricao }}

          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtn.length - 1 }") {{ scope.row.descricao }} &nbsp
            el-tooltip(
              v-if="scope.row.tipoDesconto === 'RESPEITA_LEGISLACAO_AMBIENTAL' || scope.row.tipoDesconto === 'TEM_DIREITO_REGULARIZACAO'",
              effect='dark',
              :content="getMensagem(scope.row.tipoDesconto)",
              placement="top"
            )
              font-awesome-icon.icon(icon="info-circle" size="1x")
        el-table-column(label="Valor (R$)", prop="valor")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtn.length - 1 }") {{ scope.row.valor | formatDouble }}
        el-table-column(label="Quantidade em UPFPA", prop="quantidadeUPFPA")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtn.length - 1 }") {{ scope.row.quantidadeUPFPA | formatDouble }}

    // RESUMO DOS CÁLCULOS TOTAIS PARA PAGAMENTO PARCELADO
    .px-30(v-if="formaPagamento === 'PARCELADO' && !excedente")
      el-table.mt-3(
        :data="dadosVtn.calculosVtn.resumoVtnParcelas",
      )
        el-table-column(label="Detalhamento das parcelas", prop="descricao")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtnParcelas.length - 1 }") {{ scope.row.descricao }}
        el-table-column(label="Data vencimento", prop="dataVencimento")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtnParcelas.length - 1 }") {{ scope.row.dataVencimento || '-' }}
        el-table-column(label="Valor (R$)", prop="valor")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtnParcelas.length - 1 }") {{ scope.row.valor | formatDouble }}
        el-table-column(label="Quantidade em UPFPA", prop="quantidadeUPFPA")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtnParcelas.length - 1 }") {{ scope.row.quantidadeUPFPA | formatDouble }}
    // RESUMO DOS CÁLCULOS TOTAIS PARA PAGAMENTO Á VISTA DE EXCEDENTE
    .px-30(v-if="(formaPagamento === 'A_VISTA' || formaPagamento === 'PARCELADO') && excedente && tipoProcesso !== 'CERTIDAO_TITULO'")
      el-table.mt-3(
          v-if="dadosVtn.calculosVtn.resumoParcelaExcedente"
          :data="dadosVtn.calculosVtn.resumoParcelaExcedente"
        )
          el-table-column(label="Resumo", prop="descricao")
            template(slot-scope="scope")
              span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoParcelaExcedente.length - 1 }") {{ scope.row.descricao }} &nbsp
              el-tooltip(v-if="scope.row.descricao === 'Custas agrárias'", effect='dark', :content='msgAgrarias', placement="right")
                i.fa.fa-question-circle
          el-table-column(label="Valor (R$)", prop="valor")
            template(slot-scope="scope")
              span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoParcelaExcedente.length - 1 }") {{ scope.row.valor | formatDouble }}
          el-table-column(label="Quantidade em UPFPA", prop="quantidadeUPFPA")
            template(slot-scope="scope")
              span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoParcelaExcedente.length - 1 }") {{ scope.row.quantidadeUPFPA | formatDouble }}
</template>

<script>
import messages from '@/constants/messages'

export default {

  data () {
    return {
      excedente: false
    }
  },

  props: {
    formaPagamento: {
      type: String,
      required: true
    },
    tipoProcesso: {
      type: String,
      required: true
    }
  },

  computed: {
    dadosVtn () {
      return this.$store.state.vtn.dadosVtn
    },
    getResumoVtn () {
      return this.dadosVtn?.calculosVtn?.resumoVtn
    }
  },

  methods: {
    getMensagem (tipo) {
      return messages[tipo]
    }
  },

  mounted () {
    if (this.$route.params.excedente) {
      this.excedente = this.$route.params.excedente
    }
  }

}
</script>

<style lang="scss" scoped>

  .px-30 {
    margin-top: 60px;
  }

</style>



// WEBPACK FOOTER //
// src/components/AppResumoParcelasVtn.vue